import React, { memo } from 'react';
import { Upload, Image as ImageIcon, Film, Link, MousePointerClick } from 'lucide-react';
import { NodeType } from '../types';

interface WelcomeScreenProps {
  onAddNode: (type: NodeType, position?: { x: number; y: number }, initialData?: Record<string, unknown>) => string | undefined;
  visible: boolean;
}

export const WelcomeScreen: React.FC<WelcomeScreenProps> = memo(({ onAddNode, visible }) => {
  if (!visible) return null;

  return (
    <div className={`absolute inset-0 flex flex-col items-center justify-center transition-all duration-700 z-50 pointer-events-none ${visible ? 'opacity-100 scale-100' : 'opacity-0 scale-105'}`}>
      <div className="flex items-center gap-2 mb-6 text-zinc-500 text-xs font-medium tracking-wide opacity-60">
        <div className="px-1.5 py-0.5 rounded-md bg-zinc-800/50 border border-zinc-700/50 text-[10px] flex items-center gap-1">
          <MousePointerClick size={10} />
          <span>双击</span>
        </div>
        <span>画布自由生成，或点击下方按钮创建节点</span>
      </div>
      <div className={`flex items-center gap-1.5 p-1.5 rounded-[18px] bg-[#09090b]/80 border border-white/5 backdrop-blur-xl shadow-2xl ${visible ? 'pointer-events-auto' : 'pointer-events-none'}`}>
        <button onClick={() => onAddNode(NodeType.MEDIA_UPLOAD)} className="flex items-center gap-2.5 px-5 py-3 rounded-[14px] bg-[#18181b] hover:bg-[#27272a] text-zinc-400 hover:text-zinc-100 transition-all border border-white/5 hover:border-white/10 group shadow-sm hover:shadow-md hover:-translate-y-0.5 duration-300">
          <Upload size={16} className="text-zinc-500 transition-colors group-hover:text-orange-400" />
          <span className="text-[13px] font-medium tracking-wide">媒体上传</span>
        </button>
        <button onClick={() => onAddNode(NodeType.IMAGE_GENERATOR)} className="flex items-center gap-2.5 px-5 py-3 rounded-[14px] bg-[#18181b] hover:bg-[#27272a] text-zinc-400 hover:text-zinc-100 transition-all border border-white/5 hover:border-white/10 group shadow-sm hover:shadow-md hover:-translate-y-0.5 duration-300">
          <ImageIcon size={16} className="text-zinc-500 transition-colors group-hover:text-cyan-400" />
          <span className="text-[13px] font-medium tracking-wide">图片生成</span>
        </button>
        <button onClick={() => onAddNode(NodeType.VIDEO_GENERATOR)} className="flex items-center gap-2.5 px-5 py-3 rounded-[14px] bg-[#18181b] hover:bg-[#27272a] text-zinc-400 hover:text-zinc-100 transition-all border border-white/5 hover:border-white/10 group shadow-sm hover:shadow-md hover:-translate-y-0.5 duration-300">
          <Film size={16} className="text-zinc-500 transition-colors group-hover:text-purple-400" />
          <span className="text-[13px] font-medium tracking-wide">视频生成</span>
        </button>
        <button onClick={() => onAddNode(NodeType.VIDEO_GENERATOR, undefined, { generationMode: 'FIRST_LAST_FRAME' })} className="flex items-center gap-2.5 px-5 py-3 rounded-[14px] bg-[#18181b] hover:bg-[#27272a] text-zinc-400 hover:text-zinc-100 transition-all border border-white/5 hover:border-white/10 group shadow-sm hover:shadow-md hover:-translate-y-0.5 duration-300">
          <Link size={16} className="text-zinc-500 transition-colors group-hover:text-emerald-400" />
          <span className="text-[13px] font-medium tracking-wide">首尾插帧</span>
        </button>
      </div>
    </div>
  );
});
